import { User, UserSignupPurpose } from "@common/types/user";
import { Entity } from "@common/types/entity";
import {
    AccountantOnboardingRoute,
    getAccountantOnboardingRoute,
} from "@common/billing";
import { Workspace } from "@common/types/workspace";
import { FinancialAccount } from "@common/types/financialAccount";
import { Organization } from "@common/types/organization";

export interface FlowContext {
    user: Pick<
        User,
        "preferredName" | "signupPurpose" | "bookedEnterpriseCall"
    >;
    entity: Entity;
    workspace: Workspace | null;
    organization: Organization | null;
    financialAccounts: FinancialAccount[];
    isSubscribed: boolean;
    isMobile: boolean;
}

export const ctx = {
    hasPurpose: (c: FlowContext) => !!c.user.signupPurpose,

    hasProfile: (c: FlowContext) =>
        !!c.user.preferredName && !!c.entity.legalType && !!c.entity.name,

    hasAccounts: (c: FlowContext) => c.financialAccounts.length > 0,

    isFromUS: (c: FlowContext) => c.entity.profile?.country === "US",

    isFreshbooks: (c: FlowContext) =>
        c.workspace?.isFreshbooksCustomer ?? false,

    isAccountant: (c: FlowContext) =>
        c.user.signupPurpose === UserSignupPurpose.ACCOUNTANT,

    hasWaitlistComment: (c: FlowContext) => !!c.entity.profile?.waitlistComment,

    hasFirmSize: (c: FlowContext) => !!c.organization?.profile?.firmSize,

    accountantRoute: (c: FlowContext) =>
        getAccountantOnboardingRoute(c.organization?.profile),

    needsAccountantCall: (c: FlowContext) =>
        ctx.accountantRoute(c) !== AccountantOnboardingRoute.SELF_SERVE,

    firmClientsOnlyOutsideOfUS: (c: FlowContext) =>
        !!c.organization?.clientCountries?.length &&
        c.organization?.clientCountries.every((country) => country !== "US"),

    hasBookedEnterpriseCall: (c: FlowContext) => !!c.user.bookedEnterpriseCall,
};
